import { useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useGranularEffect } from 'granular-hooks';
import { Ticker } from './components/ui/Ticker';
import { set } from 'date-fns';
import { NumericFormat } from 'react-number-format';

import classes from './App.module.css';

import ProductDetails from './components/product/ProductDetails';
import AttributeList from './components/attributes/AttributeList';
import AddToCart from './components/ui/AddToCart';
import Trustspot from "./components/trustspot/Trustspot";

function App() {
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(true);
	const [selectedAttributes, setSelectedAttributes] = useState([]);
	const [loadedAttributes, setLoadedAttributes] = useState([]);
	const [product, setProduct] = useState([]);
	const [addons, setAddons] = useState([]);
	const [categoryName, setCategoryName] = useState("");
	const [categoryContent, setCategoryContent] = useState([]);
	const [trustspotReviews, setTrustspotReviews] = useState({});
	const [step, setStep] = useState(1);
	const [totalSteps, setTotalSteps] = useState(1);
	const [employeeFlag, setEmployeeFlag] = useState(false);
	const [employeeInfoToggle, setEmployeeInfoToggle] = useState(true);
	const didMountRef = useRef(0);
	const sku = new URLSearchParams(useLocation().search).get('sku');

	//countdown timer
	var next = new Date();
	var dateLabel = "TODAY";
	if(next.getHours() >= 16) {
		next.setDate(next.getDate()+1);
		dateLabel = "TOMORROW";
	}
	while(next.getDay() === 6 || next.getDay() === 0) {
		next.setDate(next.getDate() + 1);
		dateLabel = "MONDAY";
	}

	const futureDate = set(new Date(), {
		month: next.getMonth(),
		date: next.getDate(),
		hours: 16,
		minutes: 0,
		seconds: 0
	});

	//when an attribute is clicked
	function updateSelectedAttributes(attrTypeId, attrId, maavStep) {
		loadedAttributes.splice(maavStep, loadedAttributes.length);
		let keys = Object.keys(selectedAttributes);
		keys.forEach((el)=>{
			if(selectedAttributes[el].maavStep > maavStep) {
				delete selectedAttributes[el];
			}
		});
		setSelectedAttributes(selectedAttributes => ({...selectedAttributes, [attrTypeId]: {maavStep:maavStep, attrId:attrId}}));
		setStep(maavStep+1);
	}

	//run on change to selected attributes
	useGranularEffect(() => {
		if(didMountRef.current === 0 || didMountRef.current > 1) {
			setIsLoading(true);
			const categoryData = {};
			categoryData.sku = sku;
			categoryData.Slug = window.location.pathname;
			categoryData.Attrs = selectedAttributes;
			categoryData.Step = step;

			fetch(
				'/shop/maav_getCategory',
				{
					method: 'POST',
					body: JSON.stringify(categoryData),
					headers: {
						'Content-Type': 'application/json',
						'HTTP_X_REQUESTED_WITH': 'xmlhttprequest'
					}
				}
			).then(response => {
				return response.json();
			}).then(data => {
				setEmployeeFlag(data.user_employee === 1);
				setEmployeeInfoToggle(data.user_employee === 1);
				setTotalSteps(data.details.maavSteps);
				setCategoryContent(
					{content:{
						description:data.details.maavContent, 
						media:{img:[{filename_webp:data.details.maavContentImg}]},
						product_relations:{}
					}}
				);

				if(didMountRef.current === 1) {
					data.jsondata.Attrs.forEach((el, index)=>{
						if(typeof data.jsondata.product !== "undefined") {
							setLoadedAttributes(loadedAttributes => [...loadedAttributes, data.jsondata.Attrs[index]]);
							setStep(data.details.maavSteps+1);
							data.jsondata.product.attributes.forEach((attr, i)=>{
								if(data.jsondata.product.attributes[i].attrType_id === data.jsondata.Attrs[index].attributeTypes_id) {
									setSelectedAttributes(selectedAttributes => ({...selectedAttributes, [data.jsondata.product.attributes[i].attrType_id]: {maavStep:data.jsondata.Attrs[index].maavStep, attrId:data.jsondata.product.attributes[i].attr_id}}));
								}
							});
							setProduct(data.jsondata.product);
							if(typeof data.jsondata.product.product_relations !== "undefined") {
								setAddons(data.jsondata.product.product_relations.addons);
							}
						} else {
							if(el.maavStep === step) {
								setLoadedAttributes(loadedAttributes => [...loadedAttributes, data.jsondata.Attrs[index]]);
							}
							setSelectedAttributes([]);
							setCategoryName(data.name);
						}

					});
				} else {
					data.jsondata.Attrs.forEach((el, index)=>{
						if(el.maavStep === step) {
							setLoadedAttributes(loadedAttributes => [...loadedAttributes, data.jsondata.Attrs[index]]);
							if(data.jsondata.Attrs[index].values.length === 1 || data.jsondata.Attrs[index].autoSelect === 1) {
								updateSelectedAttributes(data.jsondata.Attrs[index].values[0].typeID, data.jsondata.Attrs[index].values[0].id, data.jsondata.Attrs[index].values[0].maavStep)
							}
						}
					});
					if(data.details.maavAttrs.length === Object.keys(selectedAttributes).length) {
						setProduct(data.jsondata.product);
						if(typeof data.jsondata.product.product_relations !== "undefined") {
							setAddons(data.jsondata.product.product_relations.addons);
						}
						history.push({
							pathname: window.location.pathname,
							search: '?sku=' + data.jsondata.product._netsuite_externalId
						})
						document.querySelector('#root').scrollIntoView({behavior: "smooth"}, 500);
					} else {
						if(!Array.isArray(product)) {
							setProduct([]);
						}
						history.push({
							pathname: window.location.pathname,
							search: ''
						})
					}
				}
				setIsLoading(false);
			});

			if(didMountRef.current === 0) {
				didMountRef.current += 1;
			}
		} else {
			didMountRef.current += 1;
		}
	}, [selectedAttributes], [history, loadedAttributes, step, sku, product, updateSelectedAttributes]);

	//run on product change
	useGranularEffect(() => {
		if(didMountRef.current > 1) {
			//affirm
			var _affirm_config = {
			   public_api_key:  "A8QCSQSDLQBVHQWF",
			   script:          "https://cdn1.affirm.com/js/v2/affirm.js"
			 };
			(function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");

			//trustspot
			window.trustspot_init();
		}
	}, [product], []);

	//initial page load
	if(didMountRef.current === 0) {
		return (
			<section>
				<p>Loading...</p>
			</section>
		);
	}

	return (
		<section className={"row"}>
			<div className={"col-sm-5"}>
				<ProductDetails product={(typeof product.id !== "undefined") ? product : categoryContent.content}/>
			</div>
			<div className={"col-sm-7"}>
			{(employeeFlag) &&
				<p className={"alert alert-warning text-center infoBar"}>
					<small>sku: {product._netsuite_externalId} / Qty On Hand:  {product.quantityOnHand} / Site Buffer: {product.siteQuantityBuffer} / Qty Pending: {product.quantityPending} / Qty Available: {product.quantityAvailable}
						<br/>
						<a target="_blank" rel="noreferrer" href={"https://1210556.app.netsuite.com/app/common/item/item.nl?id=" + product._netsuite_internalId}>Netsuite</a>
						&nbsp;&nbsp;<a target="_blank" rel="noreferrer" href={"/sherlock/products/product?id=" + product.id}>Sherlock</a>
					</small>
				</p>
			}
			{(employeeInfoToggle) &&
				<button className={"btn btn-prod btn-info btn-sm"} id="emp-toggle-btn" onClick={() => setEmployeeFlag(!employeeFlag)}>Toggle Employee Info</button>
			}
			{(typeof product.id !== "undefined") ? 
				<div>
					<h2 dangerouslySetInnerHTML={{__html: product.product_name}} />
					<small>Item #{product._netsuite_externalId}</small>
					<h2>
						<strong className={"text-danger"}>
							<NumericFormat value={product.pricing.lowest.price} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale />
						</strong>
						<small className={`${(product.pricing.highest.price > product.pricing.lowest.price) ? classes.visible : classes.hidden}`}>
							<NumericFormat value={product.pricing.highest.price} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={' reg: $'} decimalScale={2} fixedDecimalScale />
						</small>
						<div className={`${(product.pricing.highest.price > product.pricing.lowest.price) ? classes.visible : classes.hidden}`}>
							<small>
								<strong className={"text-danger sale-callout"}>SALE</strong>
								<NumericFormat value={product.pricing.highest.price - product.pricing.lowest.price} displayType={'text'} decimalScale={2} thousandSeparator={true} prefix={'save $'} suffix={' '} fixedDecimalScale />
								(<strong><NumericFormat value={100*(product.pricing.highest.price - product.pricing.lowest.price)/product.pricing.highest.price} decimalScale={0} displayType={'text'} thousandSeparator={true}/>% off</strong>)
							</small>
						</div>
					</h2>
					<div className={"affirm-as-low-as"} data-amount={product.pricing.lowest.price * 100} data-page-type={"product"} data-sku={product._netsuite_externalId}></div>
					<Trustspot product={product} type={'stars'}/>
				</div> 
				:
				<h2>{categoryName}</h2>
			}
				<div className={classes.attributeContainer}>
					{isLoading && 
					<div>
						<div className={classes.pag_overlay}>
							<div className={classes.pag_spinner}>
							  <i className={"fa fa-spinner fa-4x fa-spin"}></i>
							</div>
						</div>
					</div>}
					<AttributeList attributes={loadedAttributes} selected={selectedAttributes} filter={updateSelectedAttributes} step={step}/>
				</div>
				<div className={classes.clearfix}></div>
				{(typeof product.id !== "undefined") && 
					<AddToCart product={product} addons={addons} showQuantity={true} disableAfterAdd={false} totalSteps={totalSteps} step={step}/>
				}
				{ (step <= totalSteps) && <button id={"finish_btn"} type="submit" className={"btn btn-prod btn-lg btn-disabled cart-add liner-add"} disabled={"disabled"}><span className={"glyphicon glyphicon-shopping-cart"}></span>Finish Selection</button> }
				{ (product.quantityOnHand > 0) &&
					<div className={classes.countdownTimer}>
						<Ticker futureDate={futureDate} dateLabel={dateLabel} />
					</div> }
			</div>
			<div className={classes.clearfix}></div>
		</section>
	);
}


export default App;
/*
*/